import axios from 'axios';
import store from '@/store';
import router from './router';

axios.defaults.timeout = 100000;
axios.defaults.baseURL = process.env.VUE_APP_API;

axios.interceptors.request.use((config) => {
  var jwt_token = store.getters.jwtToken;
  config.headers['Authorization'] = `Bearer ${jwt_token}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use(
  response => {
    if (response.headers.logout_out_in) {
      store.commit('USER_EXTEND_LOGIN', response.headers.logout_out_in);
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // clear login until to force display login page
          store.commit('USER_LOGOUT');
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath },
          });
          break;
        default:
          store.commit(
            'DISPLAY_ERROR',
            `${error.response.status} ${error.response.statusText}`
          );
          break;
      }
      console.log(error.response);
    } else {
      console.log(error.message);
    }
    return Promise.reject(error);
  }
);

export default axios;
